<script>
import { mapGetters, mapActions } from "vuex";
import { apiService } from "@/_services";
import _filter from "lodash/filter";
import _merge from "lodash/merge";
export default {
  name: "checkout-plan",

  data() {
    return {
      optionPlans: 0,
      optionMonths: 1,
      optionUpgrade: 0,
      step: 0
    };
  },

  currentPlan: null,
  ibranchPlans: null,

  created() {
    this.$options.currentPlan = this.userPlan;
    this.$options.ibranchPlans = this.ibranchPlans;
  },

  computed: {
    ...mapGetters("config", ["ibranchPlans", "userPlan"]),
    salablePlans() {
      return _filter(this.$options.ibranchPlans, o => {
        if (this.$options.currentPlan) {
          return o.price > this.$options.currentPlan.price;
        }
        return o.price;
      });
    },
    currentPlan() {
      if (
        this.userPlan &&
        {}.hasOwnProperty.call(this.$options.ibranchPlans, this.userPlan.sku)
      ) {
        return _merge(
          {},
          this.userPlan,
          this.$options.ibranchPlans[this.userPlan.sku]
        );
      }
      return null;
    },
    orderPlan() {
      if (this.optionUpgrade || !this.$options.currentPlan)
        return this.selectedPlan;
      return this.$options.currentPlan;
    },
    selectedPlan() {
      return this.salablePlans[this.optionPlans];
    },
    upgradeProrate() {
      if (!this.$options.currentPlan) return null;
      if (this.$options.currentPlan.sku !== this.orderPlan.sku) {
        let diff = this.orderPlan.price - this.$options.currentPlan.price;
        let daily_diff = diff / 30;
        let prorate = daily_diff * this.$options.currentPlan.expiry_days;
        let description = this.$options.currentPlan.expiry_days;
        description += description > 1 ? " days." : " day.";
        return {
          title: "Plan Upgrade PRORATE",
          description: "Prorate of " + description,
          price: parseFloat(prorate.toFixed(2))
        };
      }
      return null;
    },
    orderTotal() {
      let amount = this.optionMonths * parseFloat(this.orderPlan.price);
      if (this.upgradeProrate) {
        amount = amount + this.upgradeProrate.price;
      }
      return parseFloat(amount.toFixed(2));
    },
    switchText() {
      return this.optionUpgrade ? "Yes" : "No";
    }
  },

  methods: {
    async createOrder() {
      let data = {};
      data.sku = this.orderPlan.sku;
      data.quantity = this.optionMonths;
      try {
        const response = await apiService.checkout.with_paypal__createOrder__forPlan(
          data
        );
        // console.log(response);
        return Promise.resolve(response.id);
      } catch (error) {
        // console.log(error);
        return Promise.reject(error);
      }
    },
    captureOrder(paypal_order_id) {
      let loading = this.$buefy.loading.open({ container: null });
      return apiService.checkout
        .capture(paypal_order_id)
        .then(() => {
          this.$parent.close();
          loading.close();
          this.$buefy.dialog.alert("Your plan has been upgraded!");
        })
        .catch(err => {
          console.log(err);
          this.$parent.close();
          loading.close();
          this.$buefy.dialog.alert({
            // title: 'Error',
            message:
              "There was a problem processing your order. Try again later.",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa"
          });
        })
        .finally(() => {
          this.forceClientUpdate();
        });
    },
    paypalSetup() {
      if (this.step !== 1) return;
      let $this = this;
      // eslint-disable-next-line no-undef
      paypal
        .Buttons({
          createOrder: function() {
            let order = $this.createOrder();
            return order;
          },
          onApprove: function(data) {
            // console.log("onApprove data", data);
            $this.captureOrder(data.orderID);
          }
        })
        .render("#paypal-button-container");
    },
    ...mapActions("config", ["forceClientUpdate"])
  },

  mounted() {
    this.$nextTick(() => {
      this.paypalSetup();
    });
  },

  watch: {
    step() {
      this.$nextTick(() => {
        this.paypalSetup();
      });
    }
  }
};
</script>

<template>
  <div id="checkout-plan" class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title" v-if="step == 0">Plan Checkout</p>
      <p class="modal-card-title" v-if="step == 1">Order Review</p>
    </header>
    <section class="modal-card-body step0" v-if="step == 0">
      <div v-if="currentPlan === null">
        <div class="content">
          <p>Please, select the plan and the duration of your convenience.</p>
        </div>
        <b-field label="Select a plan">
          <b-select v-model="optionPlans">
            <option
              v-for="(product, index) in salablePlans"
              :key="index"
              :value="index"
            >
              {{ product.title }}, USD
              {{ product.price }}
            </option>
          </b-select>
        </b-field>
        <b-field label="How many months?">
          <b-numberinput
            controls-position="compact"
            v-model.number="optionMonths"
            min="1"
            max="36"
            type="is-ligth"
          ></b-numberinput>
        </b-field>
      </div>

      <div v-else>
        <div>
          Current plan: <b>{{ userPlan.sku }}</b>
        </div>
        <div>
          Expires:
          <b>
            {{ userPlan.expiry_days }}
            <span v-if="userPlan.expiry_days > 1">days</span>
            <span v-else>day</span>
          </b>
        </div>
        <hr />
        <b-field label="How many months?">
          <b-numberinput
            controls-position="compact"
            v-model.number="optionMonths"
            min="1"
            max="36"
            type="is-ligth"
          ></b-numberinput>
        </b-field>
        <template v-if="salablePlans.length">
          <b-field label="Would you like to upgrade?">
            <b-switch v-model="optionUpgrade">{{ switchText }}</b-switch>
            <!-- <b-checkbox v-model="optionUpgrade">I else want to upgrade.</b-checkbox> -->
          </b-field>
          <b-field v-if="optionUpgrade" label="Select the upgrade plan">
            <b-select v-model="optionPlans">
              <option
                v-for="(product, index) in salablePlans"
                :key="index"
                :value="index"
              >
                {{ product.title }}, USD
                {{ product.price }}
              </option>
            </b-select>
          </b-field>
        </template>
        <template v-else>
          <hr />
          <div class="content">
            <small>
              <b>Looking for an upgrade?</b>
              Wow! You are some serious business. Sadly we don't have anything
              bigger for the moment.
              <!-- We are sorry to inform you that you already have our biggest plan. -->
            </small>
          </div>
        </template>
      </div>
    </section>

    <section class="modal-card-body step1" v-if="step == 1">
      <div class="content">
        <!-- <h5>Your items:</h5> -->
        <!-- <hr /> -->
        <div class="review_item">
          <div class="review_item_details">
            <b>{{ orderPlan.sku }}</b>
            <br />
            <small>
              {{ orderPlan.description }} for ${{ orderPlan.price }} per month.
            </small>
          </div>
          <div class="review_item_price">
            <strong>
              ${{ (orderPlan.price * optionMonths) | formatMoney }}
            </strong>
            <br />
            <small v-if="optionMonths > 1">{{ optionMonths }} months</small>
            <small v-else>{{ optionMonths }} month</small>
          </div>
        </div>
        <div class="review_item" v-if="upgradeProrate !== null">
          <div class="review_item_details">
            <b>{{ upgradeProrate.title }}</b>
            <br />
            <small>{{ upgradeProrate.description }}</small>
          </div>
          <div class="review_item_price">
            <strong>${{ upgradeProrate.price | formatMoney }}</strong>
          </div>
        </div>
        <hr />
        <div class="review_total">
          <b>TOTAL:</b>
          <b class="total is-size-5">USD ${{ orderTotal | formatMoney }}</b>
        </div>
      </div>
      <hr />
      <div id="paypal-button-container"></div>
    </section>
    <footer class="modal-card-foot">
      <b-button @click="$parent.close()">Close</b-button>
      <b-button @click="step = 1" v-if="step == 0">Continue</b-button>
      <b-button @click="step = 0" v-if="step == 1">Back</b-button>
    </footer>
  </div>
</template>

<style lang="scss">
@media only screen {
  #checkout-plan {
    max-width: 24rem;
    margin: 0 auto;
    option {
      font-size: 0.875em;
    }
    .review_item {
      margin-bottom: 1.25rem;
      .review_item_details {
        padding-right: 2rem;
      }
      .review_item_price {
        flex-shrink: 0;
        text-align: right;
      }
    }
    .review_item,
    .review_total {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
